'use client';
import Button from '@ui/Button';
import Typography from '@ui/Typography';
import useConnectModalStore from '@/components/store/connectModalSlice';
import useJoinNonProfitDialogStore from '@/components/store/joinNonProfitDialogSlice';
import OrgType from 'constants/orgType.constant';
import { differenceInDays, format } from 'date-fns';
import React, { useState } from 'react';
import { MdDateRange, MdLocationOn, MdWatchLater } from 'react-icons/md';
import VolunteeringDetailsDialog from '../Volunteering/volunteeringDetailsDialog';
import useHasUserSession from '@/hooks/useHasUserSession';
import { useRouter } from 'next/navigation';
import useNonProfitSignUpPopUpStore from '../store/nonProfitSignUpPopUpSlice';
import useCompanyConnectPopUpStore from '../store/companyConnectPopUpSlice';

const formatDate = (date) => {
  const dateObj = new Date(date);
  return format(dateObj, 'MMM dd');
};

const formatTime = (time) => {
  const timeObj = new Date(time);
  return format(timeObj, 'hh:mm a');
};

function VolunteeringLocationAndTime(props) {
  const { post, stack } = props;
  const { nonProfit } = post.renderProps;

  const hasUserSession = useHasUserSession();
  const router = useRouter();

  const volunteerOpportunity = {
    ...post.sourcePostData.volunteerOpportunity,
    totalVolunteers: post.sourcePostData.totalVolunteers,
  };
  const { location, startsOn, endsOn, startsAt, endsAt, type } =
    volunteerOpportunity;

  const [open, setOpen] = useState(false);

  const setShowJoinNonProfitModal = useJoinNonProfitDialogStore(
    (state) => state.setOpen,
  );
  const setShowConnectModal = useConnectModalStore((state) => state.setOpen);

  const setShowNonProfitSignUpPopUp = useNonProfitSignUpPopUpStore(
    (state) => state.setOpen,
  );
  const setShowCompanyConnectPopUp = useCompanyConnectPopUpStore(
    (state) => state.setOpen,
  );

  const handleVolunteer = () => {
    if (hasUserSession) {
      setOpen(!open);
    } else {
      if (
        [OrgType.Business, OrgType.ChangeMakers].includes(
          post.renderProps.company.orgType,
        )
      ) {
        // setShowConnectModal(true, post.renderProps.company);
        setShowCompanyConnectPopUp(true, post.renderProps.company);
      } else {
        // setShowJoinNonProfitModal(true, nonProfit);
        // setShowJoinNonProfitModal(false, post.renderProps.nonProfit);
        // const returnPath = `/onboard/nonprofit-user?nonProfitId=${post.renderProps.nonProfit?.id}`;
        // router.replace(
        //   `/api/auth/signup?returnTo=${encodeURIComponent(returnPath)}`,
        // );
        setShowNonProfitSignUpPopUp(true, post.renderProps.nonProfit);
      }
    }
  };

  const dateRangeText =
    differenceInDays(new Date(endsOn), new Date(startsOn)) === 0
      ? `${formatDate(startsOn)}`
      : `${formatDate(startsOn)} - ${formatDate(endsOn)}`;

  const timeRangeText =
    type === 'flexible'
      ? 'Flexible'
      : `${formatTime(startsAt)} - ${formatTime(endsAt)}`;

  return (
    <div>
      <div className="flex flex-col items-start gap-6 lg:flex-row lg:items-center">
        <div className="flex flex-1 items-center gap-1">
          <MdLocationOn className="h-6 w-6 shrink-0 grow-0 text-text-disabled" />
          <Typography variant="h6" className="inline-block">
            location
          </Typography>
        </div>

        <div className="flex shrink-0 grow-0 items-center gap-1">
          <MdDateRange className="h-6 w-6 shrink-0 grow-0 text-text-disabled" />
          <Typography variant="h6" className="inline-block">
            {dateRangeText}
          </Typography>
        </div>

        <div className="flex items-center gap-1">
          <MdWatchLater className="h-6 w-6 shrink-0 grow-0 text-text-disabled" />
          <Typography variant="h6" className="inline-block">
            {timeRangeText}
          </Typography>
        </div>

        {!stack && !nonProfit?.blocked && (
          <div className="ml-auto">
            <Button variant="filled" color="primary" onClick={handleVolunteer}>
              Volunteer
            </Button>
          </div>
        )}
      </div>
      {stack && !nonProfit?.blocked && (
        <div className="mt-4 w-full">
          <Button
            variant="filled"
            color="primary"
            className="w-full"
            onClick={handleVolunteer}>
            Volunteer
          </Button>
        </div>
      )}
      <VolunteeringDetailsDialog
        open={open}
        opportunity={volunteerOpportunity}
        onClose={() => setOpen(!open)}
        nonProfit={nonProfit}
        post={post}
      />
    </div>
  );
}

export default VolunteeringLocationAndTime;
